import React from "react";
import { Navigate } from "react-router-dom";
import {
  authRoutes,
  mainRoutes,
  invalidRoutes,
  compatibilityRoutes,
  syncRoutes,
} from "./AllRoutes";
import { AuthLayout, BrowserLayout, MainLayout } from "../layout";
import Page404 from "../pages/Page404";
import { routes } from "../helpers/constants";
import { deviceDetails, getUserDatailsStatus } from "../helpers/commonFunction";

const getRoutes = (user) => {
  const isNeedToSyncApp = () => {
    // const { getOldTime, getNewTime } = getUserDatailsStatus(user);
    // if (getOldTime !== getNewTime) {
    //   return true;
    // } else {
    //   return false;
    // }
    return false;
  };

  const isValidDevice = () => {
    const myDevice = deviceDetails();
    if (myDevice?.device?.type === "mobile") {
      return true;
    } else {
      return false;
    }
  };

  return [
    {
      path: routes.homepage,
      element: !isValidDevice() ? (
        <BrowserLayout />
      ) : !user ? (
        <Navigate to={routes.login} />
      ) : isNeedToSyncApp() ? (
        <Navigate to={routes.sync} />
      ) : (
        <Navigate to={routes.dashboard} />
      ),
      children: compatibilityRoutes,
    },
    {
      path: routes.homepage,
      element: !isValidDevice() ? (
        <Navigate to={routes.browserCompatibility} />
      ) : !user ? (
        <AuthLayout />
      ) : isNeedToSyncApp() ? (
        <Navigate to={routes.sync} />
      ) : (
        <Navigate to={routes.dashboard} />
      ),
      children: authRoutes,
    },
    {
      path: routes.homepage,
      element: !isValidDevice() ? (
        <Navigate to={routes.browserCompatibility} />
      ) : user ? (
        <MainLayout />
      ) : (
        <Navigate to={routes.login} />
      ),
      children: isNeedToSyncApp() ? syncRoutes : mainRoutes,
    },
    {
      path: "",
      element: !isValidDevice() ? (
        <Navigate to={routes.browserCompatibility} />
      ) : !user ? (
        <Navigate to={routes.login} />
      ) : isNeedToSyncApp() ? (
        <Navigate to={routes.sync} />
      ) : user ? (
        <Navigate to={routes.dashboard} />
      ) : (
        <Page404 />
      ),
      children: invalidRoutes,
    },
  ];
};

export default getRoutes;
